import { render, staticRenderFns } from "./showConvocationFormOrganizer.vue?vue&type=template&id=155d6b3e"
import script from "./showConvocationFormOrganizer.vue?vue&type=script&lang=js"
export * from "./showConvocationFormOrganizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports